import React, { useEffect } from 'react';
import './PublicInfoPage.css';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import { termsSections, TERMS_LAST_UPDATED } from '../../data/legalPolicies';

const TermsPage = () => {
  useEffect(() => {
    document.title = "Avisa";
  }, []);

  return (
    <div className="pip-root">
      <main className="pip-container">
        <div className="pip-card">
          <div className="pip-content-header">
            <h1 className="pip-title">Terms of Service</h1>
            <p className="pip-subtitle">Last Updated: {TERMS_LAST_UPDATED}</p>
          </div>

          <div className="pip-content-body">
            {termsSections.map((section) => (
              <section key={section.id} className="pip-section">
                <div className="pip-section-header">
                  <span className="pip-section-number">
                    {section.id.toString().padStart(2, '0')}
                  </span>
                  <h3>{section.title}</h3>
                </div>
                {section.paragraphs?.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
                {section.bullets && (
                  <ul>
                    {section.bullets.map((b, idx) => (
                      <li key={idx}>{b}</li>
                    ))}
                  </ul>
                )}
                {section.afterBullets?.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </section>
            ))}

            <footer className="pip-footer">
              <p>By using Avisa, you agree to these terms of service</p>
              <p>© 2026 Avisa. All rights reserved.</p>
            </footer>
          </div>
        </div>
      </main>
      <ScrollToTopButton />
    </div>
  );
};

export default TermsPage;
